var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallLogsIcon = function SvgCallLogsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 10.5V12H9v-1.5zm-6 5.25h2.25v-1.5H9zm12-10.5V21a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 21V5.25A2.25 2.25 0 0 1 5.25 3h3.848a3 3 0 0 1 5.804 0h3.848A2.25 2.25 0 0 1 21 5.25m-4.5 9v-6h-9V18c0 .414.336.75.75.75H12V16.5a2.25 2.25 0 0 1 2.25-2.25zm-2.25 1.5a.75.75 0 0 0-.75.75v1.943l2.692-2.693zM9 6.75h6V4.5h-1.5v-.75a1.5 1.5 0 0 0-3 0v.75H9zm10.5-1.5a.75.75 0 0 0-.75-.75H16.5V6A2.25 2.25 0 0 1 18 8.115v7.943l-4.193 4.192H8.25A2.25 2.25 0 0 1 6 18V8.093A2.25 2.25 0 0 1 7.5 6V4.5H5.25a.75.75 0 0 0-.75.75V21c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75z",
    clipRule: "evenodd"
  })));
};
export default SvgCallLogsIcon;